var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrow-container"},[_c('f-view-heading',{attrs:{"title":_vm.$t('view_validator_list.title')}}),_c('f-validators-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }